<template>
  <div class="nav-bottom">
    <ul class="nav nav-fill">
      <li class="nav-item" v-if="state.currentUser">
        <router-link :to="{name: 'customer-overview'}" class="nav-link" href="#">
          <Icon icon-name="home-outline"></Icon>
          <span class="nav-text">{{ $t('BottomNav.overview') }}</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="state.currentUser">
        <router-link :to="{name: 'loans'}" class="nav-link" href="#">
          <Icon icon-name="file-text-outline"></Icon>
          <span class="nav-text">{{ $t('BottomNav.loans') }}</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="!state.currentUser">
        <router-link :to="{name: 'home'}" class="nav-link" href="#">
          <Icon icon-name="home"></Icon>
          <span class="nav-text">{{ $t('BottomNav.my') }}</span>
        </router-link>
      </li>
      <li class="nav-item" v-if="showCardMenuItem">
        <router-link :to="{name: 'mastercard'}" class="nav-link" href="#">
          <Icon icon-name="card-outline"></Icon>
          <span class="nav-text">{{ $t('BottomNav.mastercard') }}</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{name: 'locations'}" class="nav-link" href="#">
          <Icon icon-name="pin-outline"></Icon>
          <span class="nav-text">{{ $t('BottomNav.locations') }}</span>
        </router-link>
      </li>
      <li class="nav-item">
        <router-link :to="{name: 'contacts'}" class="nav-link">
          <Icon icon-name="phone-call-outline"></Icon>
          <span class="nav-text">{{ $t('BottomNav.contact') }}</span>
        </router-link>
      </li>
    </ul>
    <ul class="nav nav-fill d-none d-sm-flex mt-sm-auto" v-if="state.currentUser">
      <li class="nav-item">
        <a @click.prevent="logOut()" :to="{name: 'home'}" class="nav-link" href="#">
          <Icon icon-name="log-out"></Icon>
          <span class="nav-text">{{$t('AccountPage.logout')}}</span>
        </a>
      </li>
    </ul>
    <ul class="nav nav-fill d-none d-sm-flex mt-sm-auto" v-else>
      <li class="nav-item">
        <a :href="$t('BottomNav.mainSiteUrl')" class="nav-link text-primary">
          <Icon icon-name="globe-2-outline"></Icon>
          <span class="nav-text">{{$t('BottomNav.mainSiteName')}}</span>
        </a>
      </li>
    </ul>
  </div>
</template>

<script>
import Icon from '@shared/components/Icon'
import store from '@shared/store'
import UserMixin from '@shared/mixins/UserMixin'

export default {
    name: 'BottomNav',
    components: { Icon },
    mixins: [UserMixin],
    data () {
      return {
        state: store.state,
        cards: store.getCustomerCards()
      }
    },
    mounted() {
      document.body.classList.add('has-bottom-nav')
    },
    destroyed() {
      document.body.classList.remove('has-bottom-nav')
    },
    computed: {
      showCardMenuItem() {
        return this.cards.length > 0
      }
    }
  }
</script>
